export default __webpack_public_path__ + "static/media/meraki-shop-page.6031cf61.svg";